import React, { useEffect, useState } from 'react';
import { Content, Container, ContenTooltip } from './styles';

interface TooltipProps {
  text?: any;
  contentPopUp?: any;
  show?: boolean;
  showWithExternalAction?: boolean
}

const Tooltip: React.FC<TooltipProps> = ({
  text,
  contentPopUp,
  showWithExternalAction = false,
  show = false,
}) => {
  const [showTooltip, setShowTooltip] = useState<boolean>(false);
  const [contentRef, setContentRef] = useState<any>(null);

  useEffect(() => {
    setShowTooltip(show);
  }, [show]);

  return (
    <div ref={(newRef) => setContentRef(newRef)}>
      <Container>
        <Content
          onMouseOver={() => !showWithExternalAction && setShowTooltip(true)}
          onMouseOut={() => !showWithExternalAction && setShowTooltip(false)}
        >
          {text}
        </Content>
      </Container>
      {showTooltip && (
        <ContenTooltip
          theme={{
            left: contentRef?.offsetLeft - contentRef?.offsetWidth / 2,
            top: contentRef?.offsetTop + (contentRef?.offsetHeight + 5),
          }}
        >
          {contentPopUp || text}
        </ContenTooltip>
      )}
    </div>
  );
};

export default Tooltip;
